import Vue from 'vue'
import './plugins/vuetify'
import './plugins/vuestash'
import './plugins/confirm-dialog'
import App from './App.vue'
import router from './router'
import { store } from '@/store'
import 'flag-icon-css/css/flag-icon.css'
import './filters'

Vue.config.productionTip = false

new Vue({
  router,
  render: (h) => h(App),
  data: {
    store: store
  },
  async created() {
    store.init()
  },
  errorCaptured: (err, vm, info) => {
    console.error('[main] uncaught error', err, vm, info)
  }
}).$mount('#app')
